import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Alert } from 'react-bootstrap';
import {
  CartesianGrid,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { green500 } from 'styles/colors';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import messages from './messages';
import ElevationTooltip from './ElevationTooltip';
import { useElevation } from './ElevationProvider';

const AscentInfo = styled.div`
  position: absolute;
  bottom: 5px;
  right: 20px;
`;

function Chart(props) {
  const { points, width, height, intl } = props;
  const { setLocation } = useElevation();

  const xLabel = {
    value: intl.formatMessage(messages.distanceLabel),
    position: 'bottom',
    offset: -10,
  };
  const yLabel = {
    value: intl.formatMessage(messages.elevationLabel),
    angle: -90,
    position: 'left',
    offset: -10,
  };

  function handleMouse(data) {
    const location =
      data && data.activePayload && data.activePayload[0].payload.location;
    setLocation(location);
  }

  return points && points.length ? (
    <div>
      <LineChart
        width={width}
        height={height}
        data={points}
        margin={{ top: 20, right: 20, left: 10, bottom: 10 }}
        onMouseMove={handleMouse}
        onMouseLeave={() => setLocation(null)}
      >
        <XAxis dataKey="distance" type="number" label={xLabel} />
        <YAxis domain={['auto', 'auto']} label={yLabel} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip content={<ElevationTooltip />} animationDuration={100} />
        <Line
          type="monotone"
          dataKey="elevation"
          dot={false}
          stroke={green500}
          animationDuration={100}
        />
      </LineChart>
      <AscentInfo>
        <FormattedMessage
          {...messages.ascent}
          values={{ ascent: points[points.length - 1].ascent.toLocaleString() }}
        />
      </AscentInfo>
    </div>
  ) : (
    <div className="elevation-alert">
      <Alert>
        <FormattedMessage {...messages.noRoute} />
      </Alert>
    </div>
  );
}

Chart.propTypes = {
  points: PropTypes.array,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  intl: intlShape,
};

export default injectIntl(Chart);
